import { Transition } from '@headlessui/react'
import { CheckCircle, X, AlertTriangle, Info } from 'lucide-react'
import React from "react"

import { useUIStore } from "@/stores/useUIStore"

const Message: React.FC = () => {
  const { messages, removeMessage } = useUIStore()

  if (messages.length === 0) return null

  return (
    <div className="fixed top-4 right-4 z-[9999] space-y-2">
      {messages.map((message) => (
        <Transition
          key={message.id}
          show={true}
          appear={true}
          enter="transform ease-out duration-300 transition"
          enterFrom="translate-y-2 opacity-0 sm:translate-y-0 sm:translate-x-2"
          enterTo="translate-y-0 opacity-100 sm:translate-x-0"
          leave="transition ease-in duration-100"
          leaveFrom="opacity-100"
          leaveTo="opacity-0"
        >
          <div
            className={`max-w-sm p-4 rounded-lg shadow-2xl border-2 transition-all duration-300 backdrop-blur-sm ${
              message.type === "success"
                ? "bg-green-50/95 border-green-300 text-green-800 shadow-green-500/20"
                : message.type === "error"
                ? "bg-red-50/95 border-red-300 text-red-800 shadow-red-500/20"
                : message.type === "warning"
                ? "bg-yellow-50/95 border-yellow-300 text-yellow-800 shadow-yellow-500/20"
                : "bg-blue-50/95 border-blue-300 text-blue-800 shadow-blue-500/20"
            }`}
          >
            <div className="flex items-center justify-between">
              <div className="flex items-center">
                <div className="flex-shrink-0 mr-3">
                  {message.type === "success" && (
                    <CheckCircle className="w-5 h-5 text-green-600" />
                  )}
                  {message.type === "error" && (
                    <X className="w-5 h-5 text-red-600" />
                  )}
                  {message.type === "warning" && (
                    <AlertTriangle className="w-5 h-5 text-yellow-600" />
                  )}
                  {message.type === "info" && (
                    <Info className="w-5 h-5 text-blue-600" />
                  )}
                </div>
                <div className="flex-1">
                  <p className="text-sm font-medium">{message.text}</p>
                  <p className="text-xs opacity-75 mt-1">
                    {message.timestamp.toLocaleTimeString()}
                  </p>
                </div>
              </div>
              {!message.autoHide && (
                <button
                  onClick={() => removeMessage(message.id)}
                  className="ml-3 flex-shrink-0 p-1 rounded-full hover:bg-gray-200 transition-colors focus:outline-none focus:ring-2 focus:ring-gray-400"
                >
                  <X className="w-4 h-4" />
                </button>
              )}
            </div>
          </div>
        </Transition>
      ))}
    </div>
  )
}

export default Message